export const FINANCIAL_PROFILE_API_PATH = {
  GET_ALL: "v1/financial-profile/",
  GET: "v1/financial-profile/{0}/",
  PATCH: "v1/financial-profile/{0}/",
  UNLINK: "v1/financial-profile/{0}/unlink/",
};
